 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9781416503712XHTMLCOVER from '@/components/e9781416503712/xhtml/cover'
 import E9781416503712XHTMLFM01 from '@/components/e9781416503712/xhtml/fm01'
 import E9781416503712XHTMLSS_US_ADULT_SIGNUP_FRONT from '@/components/e9781416503712/xhtml/SS_US_adult_signup_front'
 import E9781416503712XHTMLFM02 from '@/components/e9781416503712/xhtml/fm02'
 import E9781416503712XHTMLFM03 from '@/components/e9781416503712/xhtml/fm03'
 import E9781416503712XHTMLFM04 from '@/components/e9781416503712/xhtml/fm04'
 import E9781416503712XHTMLFM05 from '@/components/e9781416503712/xhtml/fm05'
 import E9781416503712XHTMLFM05A from '@/components/e9781416503712/xhtml/fm05a'
 import E9781416503712XHTMLCH01 from '@/components/e9781416503712/xhtml/ch01'
 import E9781416503712XHTMLCH01A from '@/components/e9781416503712/xhtml/ch01a'
 import E9781416503712XHTMLCH01B from '@/components/e9781416503712/xhtml/ch01b'
 import E9781416503712XHTMLCH01C from '@/components/e9781416503712/xhtml/ch01c'
 import E9781416503712XHTMLCH02 from '@/components/e9781416503712/xhtml/ch02'
 import E9781416503712XHTMLCH03 from '@/components/e9781416503712/xhtml/ch03'
 import E9781416503712XHTMLCH03A from '@/components/e9781416503712/xhtml/ch03a'
 import E9781416503712XHTMLCH03B from '@/components/e9781416503712/xhtml/ch03b'
 import E9781416503712XHTMLCH03C from '@/components/e9781416503712/xhtml/ch03c'
 import E9781416503712XHTMLCH04 from '@/components/e9781416503712/xhtml/ch04'
 import E9781416503712XHTMLCH05 from '@/components/e9781416503712/xhtml/ch05'
 import E9781416503712XHTMLCH05A from '@/components/e9781416503712/xhtml/ch05a'
 import E9781416503712XHTMLCH05B from '@/components/e9781416503712/xhtml/ch05b'
 import E9781416503712XHTMLCH05C from '@/components/e9781416503712/xhtml/ch05c'
 import E9781416503712XHTMLCH06 from '@/components/e9781416503712/xhtml/ch06'
 import E9781416503712XHTMLCH07 from '@/components/e9781416503712/xhtml/ch07'
 import E9781416503712XHTMLCH07A from '@/components/e9781416503712/xhtml/ch07a'
 import E9781416503712XHTMLCH08 from '@/components/e9781416503712/xhtml/ch08'
 import E9781416503712XHTMLCH08A from '@/components/e9781416503712/xhtml/ch08a'
 import E9781416503712XHTMLCH09 from '@/components/e9781416503712/xhtml/ch09'
 import E9781416503712XHTMLCH09A from '@/components/e9781416503712/xhtml/ch09a'
 import E9781416503712XHTMLCH09B from '@/components/e9781416503712/xhtml/ch09b'
 import E9781416503712XHTMLCH10 from '@/components/e9781416503712/xhtml/ch10'
 import E9781416503712XHTMLCH10A from '@/components/e9781416503712/xhtml/ch10a'
 import E9781416503712XHTMLCH10B from '@/components/e9781416503712/xhtml/ch10b'
 import E9781416503712XHTMLCH11 from '@/components/e9781416503712/xhtml/ch11'
 import E9781416503712XHTMLCH12 from '@/components/e9781416503712/xhtml/ch12'
 import E9781416503712XHTMLCH12A from '@/components/e9781416503712/xhtml/ch12a'
 import E9781416503712XHTMLCH13 from '@/components/e9781416503712/xhtml/ch13'
 import E9781416503712XHTMLCH13A from '@/components/e9781416503712/xhtml/ch13a'
 import E9781416503712XHTMLCH14 from '@/components/e9781416503712/xhtml/ch14'
 import E9781416503712XHTMLCH14A from '@/components/e9781416503712/xhtml/ch14a'
 import E9781416503712XHTMLCH14B from '@/components/e9781416503712/xhtml/ch14b'
 import E9781416503712XHTMLCH15 from '@/components/e9781416503712/xhtml/ch15'
 import E9781416503712XHTMLCH15A from '@/components/e9781416503712/xhtml/ch15a'
 import E9781416503712XHTMLCH16 from '@/components/e9781416503712/xhtml/ch16'
 import E9781416503712XHTMLCH17 from '@/components/e9781416503712/xhtml/ch17'
 import E9781416503712XHTMLCH17A from '@/components/e9781416503712/xhtml/ch17a'
 import E9781416503712XHTMLCH18 from '@/components/e9781416503712/xhtml/ch18'
 import E9781416503712XHTMLCH18A from '@/components/e9781416503712/xhtml/ch18a'
 import E9781416503712XHTMLCH19 from '@/components/e9781416503712/xhtml/ch19'
 import E9781416503712XHTMLGLOSSARY from '@/components/e9781416503712/xhtml/glossary'
 import E9781416503712XHTMLSS_RECOMMENDPAGE from '@/components/e9781416503712/xhtml/SS_recommendpage'
 import E9781416503712XHTMLSS_US_ADULT_SIGNUP_BACK from '@/components/e9781416503712/xhtml/SS_US_adult_signup_back'
 import E9781416503712XHTMLCOPYRIGHT from '@/components/e9781416503712/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781416503712/xhtml/cover",
 			"name" : "e9781416503712/xhtml/cover",
 			"component" : E9781416503712XHTMLCOVER
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm01",
 			"name" : "e9781416503712/xhtml/fm01",
 			"component" : E9781416503712XHTMLFM01
 		},
 		{
 			"path" : "/e9781416503712/xhtml/SS_US_adult_signup_front",
 			"name" : "e9781416503712/xhtml/SS_US_adult_signup_front",
 			"component" : E9781416503712XHTMLSS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm02",
 			"name" : "e9781416503712/xhtml/fm02",
 			"component" : E9781416503712XHTMLFM02
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm03",
 			"name" : "e9781416503712/xhtml/fm03",
 			"component" : E9781416503712XHTMLFM03
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm04",
 			"name" : "e9781416503712/xhtml/fm04",
 			"component" : E9781416503712XHTMLFM04
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm05",
 			"name" : "e9781416503712/xhtml/fm05",
 			"component" : E9781416503712XHTMLFM05
 		},
 		{
 			"path" : "/e9781416503712/xhtml/fm05a",
 			"name" : "e9781416503712/xhtml/fm05a",
 			"component" : E9781416503712XHTMLFM05A
 		},
 		{
 			"path" : "/e9781416503712/xhtml/ch01",
 			"name" : "e9781416503712/xhtml/ch01",
 			"component" : E9781416503712XHTMLCH01
 		},
 		{
 			"path" : "/e9781416503712/xhtml/ch01a",
 			"name" : "e9781416503712/xhtml/ch01a",
 			"component" : E9781416503712XHTMLCH01A
 		},
 		{
 			"path" : "/e9781416503712/xhtml/ch01b",
 			"name" : "e9781416503712/xhtml/ch01b",
 			"component" : E9781416503712XHTMLCH01B
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js